import { z } from "zod";

import { imagesSchema } from "../imagesSchema";

export const nextUpSchema = z.object({
  type: z.enum(["challenge", "trivia", "deeplink"]),
  title: z.string(),
  image_url: z.url(),
  deeplink: z.string(),
  reason_code: z.enum([
    "first",
    "special_event",
    "routine",
    "community_challenge",
    "active_challenge",
    "active_campaign",
    "sunday",
    "night",
    "bible_in_a_year",
    "biy",
    "catechism_in_a_year",
    "ciy",
    "unfinished_daily",
    "unfinished_collection",
    "sunday_default_sermon",
    "random",
    "trivia",
    "unknown",
    "featured",
    "time_of_day",
  ]),
  reason_label: z.string(),
  color_hex: z.string(),
  has_access: z.boolean(),
  has_video: z.boolean(),
  description: z.string(),
  images: imagesSchema,
});

export const nextUpV3Schema = z.object({
  suggestions: nextUpSchema.array(),
});

export type NextUp = z.infer<typeof nextUpSchema>;
export type NextUpV3 = z.infer<typeof nextUpV3Schema>;
